<template>
    <v-main class='ma-0 pa-0'>
        <v-container>
            <v-row>
                <v-col cols=4 v-for='n of ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"]' :key='n'>
                  <v-btn @click='$sip.dtmf(n); var beep = new Audio("beep.mp3"); beep.play()' fab elevation='0'>{{ n }}</v-btn>
                </v-col>
              </v-row>
        </v-container>
    </v-main>
</template>

<script >
import { mapState } from "vuex";
import { Invitation } from 'sip.js';
import MediaInputSelector from './media-input-selector.vue';
import TransferMenu from './TransferMenu.vue'

export default {
  data: () =>({
  }),
  mounted() { this.attachMedia() },
  updated() { this.attachMedia() },
  computed: {
    session: {
      get() { return this.$store.getters['sip/session'] }
    },
    numberCalling: {
      // This will show the number on the dialpad, but will not always match to the session
      // TODO: get this from the session instead.
      //
      // (will matter more when there are multiple sessions)
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    isDev: {
      get() { return process.env.NODE_ENV!=='production' }
    },
  },
  methods: {
    numberFromURI(uri) {
      return uri.toString().substring(4, 10);
    }
  }
};
</script>

<style>

</style>